"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.fetch = void 0;
const constants_1 = require("../constants");
function fetch({ groupId, isMobile, }) {
    return {
        method: 'GET',
        params: {
            isMobile,
        },
        url: `/${constants_1.serverlessBaseURL}/group/${groupId}/media/fetch`,
    };
}
exports.fetch = fetch;
//# sourceMappingURL=http.js.map